import React from 'react';
import classNames from 'classnames';

const moreButton = props => (
  <div className="mx-auto more-button-container">
    <button
      className={classNames('btn btn-outline-dark rounded my-2')}
      id={props.id}
      onClick={props.onMoreButtonClick}
    >
      Load More
    </button>
  </div>
);

export default moreButton;
